<template>
    <common-modal v-if="isOpen" height="medium" width="large" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-notification ref="commonSuccessNotificationChild" :content="notificationMessage"></common-notification>
            <common-page-header
                :heading="$t('modals.patient_record.title')"
                :isCenter="true"
                contentSpacing="medium"
                contentColor="secondary"
            ></common-page-header>
            <common-content-wrapper width="large" class="details-layout">
                <patient-record-form
                    :incomingPatient="incomingPatient"
                    :patientRecords="patientRecords"
                    @cancel="emitEvent({ name: 'close' })"
                ></patient-record-form>
                <div class="patient-record__upload-container">
                    <p v-if="selectedFiles.length" class="patient-record__upload-container__title">Files to be added:</p>
                    <input
                        ref="fileInput"
                        type="file"
                        multiple="multiple"
                        style="display: none"
                        accept="application/pdf,image/png,image/jpg,image/jpeg"
                        @change="fileSelected($event)"
                    />
                    <div class="patient-record__upload-section">
                        <common-button
                            v-if="!selectedFiles || !selectedFiles.length"
                            type="primary"
                            size="large"
                            :label="$t('modals.patient_record.add.upload_records')"
                            class="patient-record__upload-btn"
                            @click="$refs.fileInput.click()"
                        ></common-button>
                        <p v-if="!selectedFiles || !selectedFiles.length">{{ $t('pages.referrals.notes.add.file_limits') }}</p>

                        <common-upload-summary
                            v-else
                            class="patient-record__upload-summary"
                            :isUploading="isUploading"
                            :files="selectedFiles"
                            @remove-file="removeFile($event)"
                        ></common-upload-summary>

                        <common-warning v-if="showWarning" size="medium" :text="warningText"></common-warning>
                    </div>
                    <common-button
                        v-if="selectedFiles.length"
                        :label="$t('modals.patient_record.upload')"
                        type="primary"
                        size="large"
                        class="patient-record__upload-btn__send-files"
                        :isDisabled="(!selectedFiles.length || isSubmitDisabled) && !$auth.isUserPracticeDemo()"
                        :isProcessing="isUploading"
                        @click="sendFiles"
                    ></common-button>
                </div>
            </common-content-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import PatientRecordForm from 'components/forms/patient/PatientRecordForm'
    import UploadMixin from 'mixins/UploadMixin'
    import PatientAPI from 'api/PatientAPI'
    export default {
        mixins: [UploadMixin],

        components: { PatientRecordForm },

        props: {
            isOpen: { type: Boolean, required: true },
            incomingPatient: { type: Object, required: true },
        },

        data() {
            return {
                selectedFiles: [],
                isUploading: false,
                showWarning: false,
                warningText: '',
                notificationMessage: '',
                patientRecords: [],
            }
        },

        methods: {
            removeFile(file) {
                this.selectedFiles = this.selectedFiles.filter((f) => f !== file)
            },

            sendFiles() {
                this.isUploading = true
                this.showWarning = false
                this.showLimits = true
                Promise.all(
                    this.selectedFiles.map((file) => {
                        if (!file.isUploaded) return this.convertFileToBase64(file)
                        return Promise.resolve(file)
                    }),
                ).then((files) => {
                    this.selectedFiles = files
                    const filesForUpload = files.filter((file) => !file.isUploaded)
                    this.uploadFiles(filesForUpload)
                })
            },

            uploadFiles(files) {
                PatientAPI.uploadPatientRecord(this.$route.params.id, this.$auth.getUser().id, files).then(() => {
                    if (this.errorFilesCount) {
                        this.warningText = this.$t('modals.patient_record.add.warnings.error', { n: this.errorFilesCount })
                        this.showWarning = true
                        this.showLimits = false
                        this.isUploading = false
                        return
                    }
                    this.sendPatientRecord()
                })
            },

            sendPatientRecord() {
                this.isUploading = false
                this.selectedFiles = []
                this.notificationMessage = this.$t('modals.patient_record.upload_success')
                this.$refs.commonSuccessNotificationChild.showNotification()
                this.getPatientRecords(this.$route.params.id, this.$auth.getUser().id)
            },

            fileSelected(event) {
                this.onFileSelected(event)
                this.$refs.fileInput.value = ''
            },

            getPatientRecords(patientId, userId) {
                PatientAPI.getPatientRecords(patientId, userId)
                    .then((res) => {
                        this.patientRecords = res
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },

        mounted() {
            this.getPatientRecords(this.$route.params.id, this.$auth.getUser().id)
        },
    }
</script>
<style>
    .details-layout {
        margin-top: 0;
    }

    .patient-record__upload-container {
        text-align: center;

        &__title {
            text-align: center;
            padding-bottom: 10px;
        }
    }

    .patient-record__upload-btn {
        width: 250px;

        &__send-files {
            text-align: center;
        }
    }

    .patient-record__upload-summary {
        display: inline-block;

        .upload-summary__files {
            display: inline-block;
        }
    }
</style>
